import { FC, useCallback, useEffect, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';
import { useCurrentWorkspace, useWorkersQuery } from '~/queries';

export const SelectEnvironment: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const { data: currentWorkspace } = useCurrentWorkspace<'safeToParse'>();
  const { data: workers, isLoading, refetch } = useWorkersQuery(currentWorkspace.id);

  const workerItems = useMemo(
    () =>
      workers
        ? workers.map(({ id, name }) => {
            return {
              label: name,
              value: id,
            };
          })
        : [],
    [workers],
  );

  useEffect(() => {
    if (endpoint.includes('workerId')) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint]);

  const onChange = useCallback(
    (environmentId: string) => {
      setVariables({
        environmentId,
      });
    },
    [setVariables],
  );

  let placeholder = workerItems.length ? `${t('choose')}...` : t('workerApi.noWorkers');

  if (isLoading) {
    placeholder = t('loading');
  }

  return !endpoint.includes('workerId') ? null : (
    <Box mb={20}>
      <Select
        label={t('workerApi.chooseWorker')}
        items={workerItems}
        onChange={onChange}
        disabled={isLoading || workerItems.length < 1}
        value={variables.environmentId}
        placeholder={placeholder}
      />
    </Box>
  );
};
